var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 7.5l4.8-4.7c.6-.6.6-1.6 0-2.2-.6-.6-1.6-.6-2.2 0L7.5 5.3 2.7.6C2.1 0 1.1 0 .5.6c-.6.6-.6 1.6 0 2.2l4.8 4.7-4.8 4.7c-.6.6-.6 1.6 0 2.2.3.3.7.5 1.1.5.4 0 .8-.2 1.1-.5l4.8-4.7 4.8 4.7c.3.3.7.5 1.1.5.4 0 .8-.2 1.1-.5.6-.6.6-1.6 0-2.2L9.7 7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.496972d518fe1a9053df2a771eeaadcb.svg";
export { ForwardRef as ReactComponent };